import React from "react";
import "../../modal.css";

export default function HomeCsatDone({ CloseChat }) {
  return (
    <div id="popup1" class="overlay open">
      <div class="chatpopup">


        <div class="feedbackdone">
          <div class="good_emo"></div>
          <div class="heading center">Thanks for your feedback</div>
          <a href="javascript:void(0)" onClick={() => CloseChat()} class="btn">Close Chat</a>
        </div>
      </div>
    </div>
  );
}
